import React, { Component } from 'react';
import Responsive from "./Responsive/Bokning";

export default class DashboardBokning extends Component {
    
    render() {
        console.log(this.props.Flags,"DDDAAASSS")
        return (
            <div>
                <div>
                    <Responsive Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/>
                </div>
            </div>
        )
    }
}
